import React from 'react';
import { useSelector } from 'react-redux';
import { Sticky } from 'react-sticky';
import { getIsBelongsToPartner } from '../../selectors';

import { ListingOverviewDesktop } from './ListingOverviewDesktop';

const ListingOverviewDesktopContainer: React.FC = () => {
  const isBelongsToPartner = useSelector(getIsBelongsToPartner);

  const [stickyHeight, setStickyHeight] = React.useState<number>();

  const handleStickyHeightChange = React.useCallback(
    (height: number) => setStickyHeight(height),
    [],
  );

  return (
    <Sticky bottomOffset={stickyHeight}>
      {({ wasSticky, isSticky, style }) => (
        <ListingOverviewDesktop
          wasSticky={wasSticky}
          isSticky={isSticky}
          style={style}
          onStickyHeightChange={handleStickyHeightChange}
          isBelongsToPartner={isBelongsToPartner}
        />
      )}
    </Sticky>
  );
};

export { ListingOverviewDesktopContainer };
